// extracted by mini-css-extract-plugin
module.exports = {"i18n-select":"i18n-select-16Na6","menu":"menu-1NcSH","i18n-label":"i18n-label-23MRd"};